module.exports = __webpack_public_path__ + "img/coupon.e2b2fdea.png";